
const config = {
};

export default config;


// WEBPACK FOOTER //
// ./src/localConfig.js